import { createContext, useContext } from "react";

import type { Course } from "~/providers/course-provider";

interface CourseContext {
  courses: Course[];
}

export const CourseContext = createContext<CourseContext | undefined>(
  undefined,
);

export const useCourse = () => {
  const context = useContext(CourseContext);

  if (context === undefined) {
    throw new Error("useCourse must be used within a CourseProvider");
  }

  return context;
};
